var map = {
	"./black-text.png": "2ac2",
	"./dcpthgz-text.png": "83f7",
	"./schgz-black-text.png": "abe0",
	"./schgz-text.png": "ddc3",
	"./wchgz-black-text.png": "117b",
	"./wchgz-text.png": "efdd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c802";